import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import TestPanelContext from './TestPanelContext';
import TestPanelReducer from './TestPanelReducer';

export default function TestPanelProvider({ children }) {
  const [state, dispatch] = useReducer(TestPanelReducer, {
    isOpen: false,
    logs: [],
    apiHistory: {
      apiHistoryItems: [],
      fetchingHistory: false,
      hasMounted: false
    },
    testAccounts: null
  });

  return (
    <TestPanelContext.Provider
      value={{
        ...state,
        toggleTestPanel: (value) => dispatch({ type: 'TOGGLE_TEST_PANEL', value }),
        updateLogs: (value) => dispatch({ type: 'UPDATE_LOGS', value }),
        updateApiHistory: (value) => dispatch({ type: 'UPDATE_API_HISTORY', value }),
        updateTestAccounts: (value) => dispatch({ type: 'UPDATE_TEST_ACCOUNTS', value }),
        resetTestPanel: (value) => dispatch({ type: 'RESET_TEST_PANEL', value })
      }}
    >
      {children}
    </TestPanelContext.Provider>
  );
}

TestPanelProvider.propTypes = {
  children: PropTypes.node.isRequired
};
